export const environment = {
  production: true
};

export const restroot = 'http://localhost:3000/';



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts